import { useEffect } from "react";
import useAxiosFunction from "./useAxiosFunction";

const useAxios = (configObj) => {
  const [response, error, loading, axiosFetch] = useAxiosFunction();

  const refetch = async () => {
    if (!configObj?.url) return null;
    return await axiosFetch(configObj);
  };

  useEffect(() => {
    if (!configObj?.url) return;
    axiosFetch(configObj);
  }, []);

  return [response, error, loading, refetch];
};

export default useAxios;
